import comp from "./WithPublicToken";
export default comp;
